import type { ContactUsConfig } from './types'
import { commonTexts } from './common'

/**
 * Fictora 品牌 Contact Us 页面配置
 */
export const contactUsConfig: ContactUsConfig = {
  texts: commonTexts,
  colors: {
    bgPrimary: '#050000',
    bgTertiary: '#1F1E20',
    textPrimary: '#FFFFFF',
    textTertiary: '#A5A5A5',
    textPlaceholder: '#A5A5A5',
    accentRed: '#FC5549',
    primaryColor: '#FF2D89',
    whiteColor: '#FFFFFF',
  },
}
